module.exports = __webpack_public_path__ + "static/img/9.34e0fbe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/eng/9.png
// module id = KXca
// module chunks = 0